import React from 'react';
import { Routes } from '@common/constants';
import BasketIndicator from '@common/components/BasketIndicator';
import { ActionButton, StyledLink } from '../../../GeneralLayout.styles';

export type BasketProps = {
  basketCount: number;
};

export const Basket: React.FC<BasketProps> = ({ basketCount }) => {
  return (
    <>
      <StyledLink route={Routes.BASKET}>
        <ActionButton>
          <BasketIndicator basketCount={basketCount} />
        </ActionButton>
      </StyledLink>
    </>
  );
};
